export const listitem = (text: string) => `<li>${text}</li>`
